// src/components/kyl_rightSidebar.jsx
import KML from 'ol/format/KML';
import GeoJSON from 'ol/format/GeoJSON';
import { Style, Stroke, Fill, Circle as CircleStyle ,Icon} from "ol/style";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { useNavigate } from "react-router-dom";
import React,{useEffect} from "react";
import SelectButton from "./buttons/select_button";
import { ArrowLeft, Loader2, Table, FileText, FileSpreadsheet, X, ChevronRight, CheckCircle2,Layers3,Users } from 'lucide-react';
import KYLMWSProfilePanel from "./kyl_MWSProfilePanel.jsx";
import KYLWaterbodyPanel from "./kyl_waterbodypanel.jsx";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx-js-style';
import toast from 'react-hot-toast';
import { buildIntersections } from '../components/utils/dataIndexes.js';
import { FILTER_BY_NAME } from '../components/utils/filtersIndex.js';
import StewardIcon from "../assets/steward_icon_final.png";
import planIcon from "../assets/plan_icon_final.png";



const KYLRightSidebar = ({
  state,
  district,
  block,
  setState,
  setDistrict,
  setBlock,
  statesData,
  handleItemSelect,
  setFilterSelections,
  getFormattedSelectedFilters,
  getFormattedSelectedPatterns,
  handlePatternRemoval,
  selectedMWS,
  selectedVillages,
  toggleStates,
  setToggleStates,
  currentLayer,
  setCurrentLayer,
  mapRef,
  onResetMWS,
  selectedMWSProfile,
  waterbodiesLayerRef,
  selectedWaterbodyProfile,
  onResetWaterbody,
  setShowWB,
  showWB,
  boundaryLayerRef,
  showConnectivity,
  setShowConnectivity,
  mwsArrowLayerRef,
  villageJson = [],
  dataJson = [],
  selectedWaterbodyIds,
  selectedWaterbodyData = [],
  isLoading,
  mwsLayerRef,
   selectionMode,
  setSelectionMode,
  manualSelectedMWS,
  onResetMWSSelection,
  showPlans,
  setShowPlans,
  showStewards,
  setShowStewards,
  mwsIndex,
  villageNameIndex,
  setManualSelectedMWS,
  handleRemoveMWS,
}) => {
  const [loadingWB, setLoadingWB] = React.useState(false);
  const [showSelectionPopup, setShowSelectionPopup] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [isExportingGeo, setIsExportingGeo] = React.useState(false);
  const [geoExportFormat, setGeoExportFormat] = React.useState(null);
  const [plans, setPlans] = React.useState([]);
  
  const [selectedPlanProfile, setSelectedPlanProfile] = React.useState(null);
  const plansLayerRef = React.useRef(null);
  const [stewards, setStewards] = React.useState([]);
  const [selectedStewardProfile, setSelectedStewardProfile] = React.useState(null);

  const stewardsLayerRef = React.useRef(null);

  const showBothPanels = selectedMWSProfile && selectedWaterbodyProfile;
  const navigate = useNavigate();

  const transformName = (name) => {
    if (!name) return name;
    return name
      .replace(/[()]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "")
      .toLowerCase()
  };

  const buildVillageReportUrl = (villageId) =>
    `${process.env.REACT_APP_API_URL}/generate_village_report/?state=${transformName(state?.label)}&district=${transformName(district?.label)}&block=${transformName(block?.label)}&villageId=${villageId}`;

  const exportBoundaries = async (format) => {
    setIsExportingGeo(true);
    setGeoExportFormat(format);

    await new Promise(r => setTimeout(r, 50));

    try {
      const features = [];

      // ── Collect filtered MWS features ──
      if (mwsLayerRef?.current) {
        const mwsSource = mwsLayerRef.current.getSource();
        mwsSource.getFeatures().forEach(f => {
          if (f.get('isFiltered') === 1) {
            const clone = f.clone();
            clone.set('_layer', 'Micro-watershed', true);
            clone.set('feature_type', 'Micro-watershed', true);
            clone.set('mws_id', f.get('uid'), true);
            clone.set('name', `Micro-watershed: ${f.get('uid') || 'Unknown'}`, true);

            clone.setStyle(new Style({
              stroke: new Stroke({ color: 'rgba(127,29,29,1)', width: 1.8 }),
              fill: new Fill({ color: 'rgba(239,68,68,0.55)' }),
            }));

            clone.unset('geometry_name', true);
            features.push(clone);
          }
        });
      }

      // ── Collect selected village features ──
      if (boundaryLayerRef?.current) {
        const vilSource = boundaryLayerRef.current.getSource();
        vilSource.getFeatures().forEach(f => {
          if (f.get('isSelected') === 1) {
            const p = f.getProperties();
            const vName = p.vill_name || p.village_name || p.name || 'Unknown';
            const vId = p.vill_ID || p.village_id || '';

            const clone = f.clone();
            clone.set('_layer', 'Village', true);
            clone.set('feature_type', 'Village', true);
            clone.set('name', `Village: ${vName}${vId ? ` (${vId})` : ''}`, true);

            clone.setStyle(new Style({
              stroke: new Stroke({ color: 'rgba(255,225,0,1)', width: 2 }),
              fill: new Fill({ color: 'rgba(255,225,0,0.15)' }),
            }));

            clone.unset('geometry_name', true);
            features.push(clone);
          }
        });
      }

      // ── Collect filtered waterbody features ──
      if (showWB && waterbodiesLayerRef?.current) {
        const wbSource = waterbodiesLayerRef.current.getSource();
        wbSource.getFeatures().forEach(f => {
          if (f.get('wbMatch') !== 1) return;

          const p = f.getProperties();
          const wbId = String(p.UID ?? p.swb_id ?? p.SWB_UID ?? p.swb_uid ?? p.uid ?? p.id ?? '');
          if (selectedWaterbodyIds && selectedWaterbodyIds.size > 0 && !selectedWaterbodyIds.has(wbId)) return;

          const wName = p.name || p.NAME || p.swb_name || p.SWB_NAME || 'Unknown';

          const clone = f.clone();
          clone.set('_layer', 'Waterbody', true);
          clone.set('feature_type', 'Waterbody', true);
          clone.set('swb_id', wbId, true);
          clone.set('swb_name', wName, true);
          clone.set('name', `Waterbody: ${wName}${wbId ? ` (${wbId})` : ''}`, true);

          clone.setStyle(new Style({
            stroke: new Stroke({ color: 'rgba(85,255,255,1)', width: 2 }),
            fill: new Fill({ color: 'rgba(85,255,255,0.45)' }),
          }));

          clone.unset('geometry_name', true);
          features.push(clone);
        });
      }

      if (features.length === 0) {
        alert('No highlighted boundaries to export.');
        return;
      }

      let output, mimeType, extension;

      if (format === 'kml') {
        const kmlFormat = new KML({ writeStyles: true });
        output = kmlFormat.writeFeatures(features, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:4326',
        });
        output = output.replace(
          '<Document>',
          `<Document><name>KYL Boundaries — ${block?.label || 'Export'}</name>`
        );
        mimeType = 'application/vnd.google-earth.kml+xml';
        extension = 'kml';
      } else {
        const geojsonFormat = new GeoJSON();
        const geojsonObj = JSON.parse(
          geojsonFormat.writeFeatures(features, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:4326',
          })
        );

        geojsonObj.name = `KYL Boundaries — ${block?.label || 'Export'}`;

        geojsonObj.features.forEach(f => {
          if (f.properties._layer === 'Micro-watershed') {
            f.properties['stroke'] = '#7f1d1d';
            f.properties['stroke-width'] = 1.8;
            f.properties['stroke-opacity'] = 1;
            f.properties['fill'] = '#ef4444';
            f.properties['fill-opacity'] = 0.55;
          } else if (f.properties._layer === 'Village') {
            f.properties['stroke'] = '#ffe100';
            f.properties['stroke-width'] = 2;
            f.properties['stroke-opacity'] = 1;
            f.properties['fill'] = '#ffe100';
            f.properties['fill-opacity'] = 0.15;
          } else if (f.properties._layer === 'Waterbody') {
            f.properties['stroke'] = '#55ffff';
            f.properties['stroke-width'] = 2;
            f.properties['stroke-opacity'] = 1;
            f.properties['fill'] = '#55ffff';
            f.properties['fill-opacity'] = 0.45;
          }
        });

        output = JSON.stringify(geojsonObj, null, 2);
        mimeType = 'application/geo+json';
        extension = 'geojson';
      }

      const blob = new Blob([output], { type: mimeType });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `kyl_boundaries_${transformName(block?.label) || 'export'}_${new Date().toISOString().split('T')[0]}.${extension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

    } catch (err) {
      console.error('Boundary export error:', err);
      alert('Error exporting boundaries. Please try again.');
    } finally {
      setIsExportingGeo(false);
      setGeoExportFormat(null);
    }
  };

  const allSelectedMWSIds = React.useMemo(() => {
  const ids = new Set();
  (selectedMWS || []).forEach(id => ids.add(String(id)));
  (manualSelectedMWS || []).forEach(id => ids.add(String(id)));
  return Array.from(ids);
}, [selectedMWS, manualSelectedMWS]);


useEffect(() => {
  if (plansLayerRef.current && mapRef.current) {
    mapRef.current.removeLayer(plansLayerRef.current);
    plansLayerRef.current = null;
  }

  setPlans([]);
  setSelectedPlanProfile(null);
  setShowPlans(false);
}, [state, district, block]);

useEffect(() => {
  if (stewardsLayerRef.current && mapRef.current) {
    mapRef.current.removeLayer(stewardsLayerRef.current);
    stewardsLayerRef.current = null;
  }

  setStewards([]);
  setSelectedStewardProfile(null);
  setShowStewards(false);
}, [state, district, block]);


  const manualSelectionDetails = React.useMemo(() => {
    if (!manualSelectedMWS?.length || !dataJson?.length) return [];

    return manualSelectedMWS.map((mwsId) => {
      const mwsRecord = dataJson.find(
        (item) => String(item.mws_id) === String(mwsId)
      );

      if (!mwsRecord) {
        return {
          mwsId,
          villages: [],
          waterbodies: [],
        };
      }

  const villages = (mwsRecord.mws_intersect_villages || []).map((villageId) => {
    let villageName = "";

    // Try villageJson
    const village = villageJson.find(
      (v) => String(v.village_id) === String(villageId)
    );

    if (village) {
      villageName =
        village.village_name ||
        village.vill_name ||
        village.name ||
        "";
    }

    // Fallback to boundary layer
    if (!villageName && boundaryLayerRef?.current) {
      try {
        const feature = boundaryLayerRef.current
          .getSource()
          .getFeatures()
          .find((feat) => {
            const p = feat.getProperties();
            return String(p.vill_ID ?? p.village_id) === String(villageId);
          });

        if (feature) {
          const p = feature.getProperties();
          villageName =
            p.vill_name ||
            p.village_name ||
            p.name ||
            "";
        }
      } catch (_) {}
    }

    return {
      villageId: String(villageId),
      villageName: villageName || "Unknown",
    };
  });

      const waterbodies = (mwsRecord.mws_intersect_swb || []).map((swb) => ({
        swbId: String(swb?.swbId ?? swb?.id ?? swb),
        swbName: swb?.swbName ?? swb?.name ?? "",
      }));

      return {
        mwsId: String(mwsId),
        villages,
        waterbodies,
      };
    });
  }, [manualSelectedMWS, dataJson, villageJson]);

  const mwsVillageIntersections = React.useMemo(
    () => buildIntersections(allSelectedMWSIds, mwsIndex, villageNameIndex),
    [allSelectedMWSIds, mwsIndex, villageNameIndex]
  );

  const handleUniversalBack = () => {
    onResetMWS();
    onResetWaterbody();
    setSelectedPlanProfile(null);
    setSelectedStewardProfile(null);
  };

  const handleIndicatorRemoval = (filter) => {
    setManualSelectedMWS([]);
    if (toggleStates[filter.name]) {
      const layerToRemove = currentLayer.find((l) => l.name === filter.name);
      if (layerToRemove) {
        layerToRemove.layerRef.forEach((layer) => {
          if (mapRef.current) mapRef.current.removeLayer(layer);
        });
        setCurrentLayer((prev) => prev.filter((l) => l.name !== filter.name));
      }
    }
    setToggleStates((prevStates) => ({ ...prevStates, [filter.name]: false }));

    const sourceType = FILTER_BY_NAME.get(filter.name)?.namespace ?? null;

    if (sourceType === "MWS") {
      setFilterSelections((prev) => ({
        ...prev,
        selectedMWSValues: { ...prev.selectedMWSValues, [filter.name]: null },
      }));
    } else if (sourceType === "Village") {
      setFilterSelections((prev) => ({
        ...prev,
        selectedVillageValues: { ...prev.selectedVillageValues, [filter.name]: null },
      }));
    } else if (sourceType === "Waterbody") {
      setFilterSelections((prev) => ({
        ...prev,
        selectedWaterbodyValues: { ...prev.selectedWaterbodyValues, [filter.name]: null },
      }));
    }
    else if (sourceType === "Waterbody") {
      setFilterSelections((prev) => ({
        ...prev,
        selectedWaterbodyValues: {
          ...prev.selectedWaterbodyValues,
          [filter.name]: null,
        },
      }));
    }
  };

  const toggleWaterbodies = () => {
    if (!waterbodiesLayerRef.current) {
      console.warn("Waterbodies layer not loaded yet");
      return;
    }

    if (!showWB) {
      const source = waterbodiesLayerRef.current.getSource();

      if (source.getState() === "ready" && source.getFeatures().length > 0) {
        waterbodiesLayerRef.current.setZIndex(9998);
        mapRef.current.addLayer(waterbodiesLayerRef.current);
        setShowWB(true);
        return;
      }

      setLoadingWB(true);
      const onSourceChange = () => {
        if (source.getState() === "ready") {
          setLoadingWB(false);
          source.un("change", onSourceChange);
        }
      };
      source.on("change", onSourceChange);

      waterbodiesLayerRef.current.setZIndex(9998);
      mapRef.current.addLayer(waterbodiesLayerRef.current);
      setShowWB(true);
    } else {
      mapRef.current.removeLayer(waterbodiesLayerRef.current);
      setShowWB(false);
    }
  };

  const toggleConnectivity = () => {
    if (!showConnectivity) {
      const hasActiveFilters = getFormattedSelectedFilters().length > 0;
      if (currentLayer.length > 0 || hasActiveFilters) {
        toast.error("Please turn off the active filters/layer before enabling MWS Connectivity.");
        return;
      }
    }

    if (!mwsArrowLayerRef?.current) { console.warn("Arrow layer not ready"); return; }
    setShowConnectivity(prev => !prev);
  };

  const fetchPlansByTehsil = async (block) => {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/watershed/plans/?tehsil=${block}&filter_test_plan=true`,
    {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "1",
        "X-API-Key": process.env.REACT_APP_API_KEY,
      },
    }
  );

  if (!res.ok) {
    throw new Error(`API Error ${res.status}`);
  }

  return res.json();
};

  const handlePlansClick = async () => {
    try {
      // Hide plans if already visible
      if (showPlans) {
        if (plansLayerRef.current) {
          mapRef.current.removeLayer(plansLayerRef.current);
        }
        setShowPlans(false);
        return;
      }

      // Plans already fetched, just show them again
      if (plans.length > 0) {
        showPlansOnMap(plans);
        setShowPlans(true);
        return;
      }

      const response = await fetchPlansByTehsil(block.block_id);

      setPlans(response);

      showPlansOnMap(response);

      setShowPlans(true);
    } catch (err) {
      console.error("Error fetching plans:", err);
    } finally {
      console.log("Plans fetched")
    }
  };

const showPlansOnMap = (plansData) => {
  if (!mapRef.current) return;

  // Remove previous plans layer
  if (plansLayerRef.current) {
    mapRef.current.removeLayer(plansLayerRef.current);
    plansLayerRef.current = null;
  }

  const features = plansData
    .filter(
      (plan) =>
        plan.latitude !== null &&
        plan.longitude !== null &&
        plan.latitude !== undefined &&
        plan.longitude !== undefined
    )
    .map((plan) => {
      const feature = new Feature({
        geometry: new Point([
          Number(plan.longitude),
          Number(plan.latitude),
        ]),
      });

      feature.set("plan", plan);
      feature.set("planDetails", plan);

  const status = getPlanStatus(plan);

    feature.setStyle(PLAN_ICON_DEFAULT(status));

      return feature;
    });

  const layer = new VectorLayer({
    source: new VectorSource({
      features,
    }),
    zIndex: 9999,
  });

  plansLayerRef.current = layer;

  mapRef.current.addLayer(layer);

  if (features.length > 0) {
    mapRef.current.getView().fit(
      layer.getSource().getExtent(),
      {
        padding: [40, 40, 40, 40],
        duration: 500,
        maxZoom: 16,
      }
    );
  }
};

const showStewardsOnMap = (stewardsData) => {
  if (!mapRef.current) return;

  // Remove old steward layer
  if (stewardsLayerRef.current) {
    mapRef.current.removeLayer(stewardsLayerRef.current);
    stewardsLayerRef.current = null;
  }

  const features = stewardsData
    .map((steward) => {
      const firstPlan = steward.plans?.find(
        (plan) =>
          plan.latitude != null &&
          plan.longitude != null
      );

      if (!firstPlan) return null;

      if (
        firstPlan.latitude == null ||
        firstPlan.longitude == null
      ) {
        return null;
      }

  const feature = new Feature({
  geometry: new Point([
    Number(firstPlan.longitude),
    Number(firstPlan.latitude),
  ]),
});
    feature.set("stewardDetails", steward); 
    feature.setStyle(STEWARD_DOT_DEFAULT());
    return feature;
    })
    .filter(Boolean);

  const layer = new VectorLayer({
    source: new VectorSource({
      features,
    }),
  });

  stewardsLayerRef.current = layer;

  mapRef.current.addLayer(layer);
};

const handleStewardsClick = async () => {
  try {
    // Hide stewards if already visible
    if (showStewards) {
      if (stewardsLayerRef.current) {
        mapRef.current.removeLayer(stewardsLayerRef.current);
        stewardsLayerRef.current = null;
      }

      setShowStewards(false);
      return;
    }

    // Already fetched, just show again
    if (stewards.length > 0) {
      showStewardsOnMap(stewards);
      setShowStewards(true);
      return;
    }

    const response = await fetchStewardsByTehsil(block.block_id);

    setStewards(response.stewards || []);
    showStewardsOnMap(response.stewards || []);

    setShowStewards(true);
  } catch (err) {
    console.error("Error fetching stewards:", err);
  } finally {
    console.log("Stewards Fetched")
  }
};

const fetchStewardsByTehsil = async (block) => {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/watershed/plans/steward-listing/?tehsil=${block}`,
    {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "1",
        "X-API-Key": process.env.REACT_APP_API_KEY,
      },
    }
  );

  if (!res.ok) {
    throw new Error(`API Error ${res.status}`);
  }

  return res.json();
};

React.useEffect(() => {
  if (!mapRef.current) return;

  let hoveredFeature = null;

  const handlePointerMove = (evt) => {
    if (!showPlans || !plansLayerRef.current) return;

    const feature = mapRef.current.forEachFeatureAtPixel(
      evt.pixel,
      (feature, layer) => {
        if (layer === plansLayerRef.current) {
          return feature;
        }
      }
    );

    // Restore previous hovered feature
    if (hoveredFeature && hoveredFeature !== feature) {
      const status = getFeatureStatus(hoveredFeature);
      hoveredFeature.setStyle(PLAN_ICON_DEFAULT(status));
      hoveredFeature = null;
    }

    // Apply hover style
    if (feature && feature !== hoveredFeature) {
      const status = getFeatureStatus(feature);
      feature.setStyle(PLAN_ICON_HOVERED(status));
      hoveredFeature = feature;
    }

    mapRef.current.getTargetElement().style.cursor = feature ? "pointer" : "";
  };

  const handlePlanClick = (evt) => {
    if (!showPlans || !plansLayerRef.current) return;

    const feature = mapRef.current.forEachFeatureAtPixel(
      evt.pixel,
      (feature, layer) => {
        if (layer === plansLayerRef.current) {
          return feature;
        }
      }
    );

    if (!feature) return;

    const plan = feature.get("planDetails");

    if (!plan) return;

    setSelectedPlanProfile(plan);
  };

  mapRef.current.on("pointermove", handlePointerMove);
  mapRef.current.on("singleclick", handlePlanClick);

  return () => {
    if (mapRef.current) {
      mapRef.current.un("pointermove", handlePointerMove);
      mapRef.current.un("singleclick", handlePlanClick);
    }
  };
}, [showPlans, navigate]);

React.useEffect(() => {
  if (!mapRef.current) return;

  let hoveredFeature = null;

  const handleStewardHover = (evt) => {
    const feature = mapRef.current.forEachFeatureAtPixel(
      evt.pixel,
      (feature, layer) => {
        if (layer === stewardsLayerRef.current) {
          return feature;
        }
      }
    );

    if (hoveredFeature && hoveredFeature !== feature) {
      hoveredFeature.setStyle(STEWARD_DOT_DEFAULT());
      hoveredFeature = null;
    }

    if (feature && feature !== hoveredFeature) {
      feature.setStyle(STEWARD_DOT_HOVERED());
      hoveredFeature = feature;
    }

    mapRef.current.getTargetElement().style.cursor =
      feature ? "pointer" : "";
  };

  const handleStewardClick = (evt) => {
  if (!showStewards || !stewardsLayerRef.current) return;

  const feature = mapRef.current.forEachFeatureAtPixel(
    evt.pixel,
    (feature, layer) => {
      if (layer === stewardsLayerRef.current) {
        return feature;
      }
    }
  );

  if (!feature) return;

  const steward = feature.get("stewardDetails");

  if (!steward) return;

  setSelectedStewardProfile(steward);
};

  mapRef.current.on("pointermove", handleStewardHover);
  mapRef.current.on("singleclick", handleStewardClick);

  return () => {
    mapRef.current?.un("pointermove", handleStewardHover);
    mapRef.current?.un("singleclick", handleStewardClick);
  };
}, [showStewards]);

// ── PLAN DOT STYLES ──────────────────────────────────────────────────────────

const PLAN_STATUS_COLORS = {
  in_progress: {fill: "#FF0000",stroke: "#8B0000",},
  dpr_completed: {fill: "#FFFF00",stroke: "#B8B800", },
  dpr_approved: {fill: "#00FF00",stroke: "#008000",},
};

const getPlanStatus = (plan) => {
  if (!plan) return "in_progress";
  if (plan.is_dpr_reviewed) return "dpr_completed";
  return "in_progress";
};

const getFeatureStatus = (feature) => getPlanStatus(feature.get("planDetails"));

const PLAN_ICON_DEFAULT = (status = "in_progress") => [
  // Status ring
  new Style({
    image: new CircleStyle({
      radius: 15,
      fill: new Fill({
        color: "transparent",
      }),
      stroke: new Stroke({
        color: PLAN_STATUS_COLORS[status].fill,
        width: 3,
      }),
    }),
  }),

  // Plan icon
  new Style({
    image: new Icon({
      src: planIcon,
      scale: 0.085,
      anchor: [0.5, 0.5],
      anchorXUnits: "fraction",
      anchorYUnits: "fraction",
    }),
  }),
];


const PLAN_ICON_HOVERED = (status = "in_progress") => [
  // Bigger status ring
  new Style({
    image: new CircleStyle({
      radius: 17,
      fill: new Fill({
        color: "transparent",
      }),
      stroke: new Stroke({
        color: PLAN_STATUS_COLORS[status].fill,
        width: 3,
      }),
    }),
  }),

  // Bigger plan icon
  new Style({
    image: new Icon({
      src: planIcon,
      scale: 0.10,
      anchor: [0.5, 0.5],
      anchorXUnits: "fraction",
      anchorYUnits: "fraction",
    }),
  }),
];


const STEWARD_DOT_DEFAULT = () =>
  [
    // White circular border
    new Style({
      image: new CircleStyle({
        radius: 18,
        fill: new Fill({
          color: "#ffffff",
        }),
      }),
    }),

    // Steward icon
    new Style({
      image: new Icon({
        src: StewardIcon,
        scale: 0.12,
        anchor: [0.5, 0.5],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
      }),
    }),
  ];

const STEWARD_DOT_HOVERED = () =>
  [
    // White circular border
    new Style({
      image: new CircleStyle({
        radius: 21,
        fill: new Fill({
          color: "#ffffff",
        }),
      }),
    }),

    // Slightly bigger steward icon on hover
    new Style({
      image: new Icon({
        src: StewardIcon,
        scale: 0.14,
        anchor: [0.5, 0.5],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
      }),
    }),
  ];

  const handleTehsilReport = () => {
    const reportURL = `${process.env.REACT_APP_API_URL}/generate_tehsil_report/?state=${transformName(state?.label)}&district=${transformName(district?.label)}&block=${transformName(block?.label)}`;
    window.open(reportURL, '_blank', 'noopener,noreferrer');
  };

  const generateSelectionTableData = () => {
    const mwsData = [];
    const villageData = [];

    if (allSelectedMWSIds && allSelectedMWSIds.length > 0) {
      allSelectedMWSIds.forEach((mwsId, index) => {
        mwsData.push({ id: `${mwsId}-${index}`, name: String(mwsId) });
      });
    }

    if (selectedVillages && selectedVillages.size > 0) {
      let villageIndex = 0;
      selectedVillages.forEach((villageId) => {
        const villageIdStr = String(villageId);
        const vName = villageNameIndex.get(villageIdStr) || '';
        villageData.push({
          id: `village-${villageIdStr}-${villageIndex}`,
          villageId: villageIdStr,
          villageName: vName || 'Unknown Village',
        });
        villageIndex++;
      });
    }

    return { mwsData, villageData };
  };

  const displayVillages = React.useMemo(() => {
    // Manual MWS selection
    if (manualSelectedMWS?.length > 0) {
      return [
        ...new Map(
          manualSelectionDetails
            .flatMap((mws) => mws.villages)
            .map((v) => [v.villageId, v])
        ).values(),
      ];
    }

    // Filter selection
    const { villageData } = generateSelectionTableData();
    return villageData;
  }, [
    manualSelectedMWS,
    manualSelectionDetails,
    selectedVillages,
    villageJson,
  ]);

  // ─── WB property display resolver — uses cached precomputed props ───
  const getWBDisplayValue = (filterName, swb) => {
  if (filterName === "waterbody_type") {
    const raw = swb.waterbody_type;
    if (raw === undefined || raw === null) return "N/A";
    return raw === "river" ? "On River" : "Off River";
  }

  if (filterName === "drainage_line") {
    // Use pre-computed if available, else compute from raw
    if (swb.wbDrainage === "onDrainage") return "On Drainage";
    if (swb.wbDrainage === "offDrainage") return "Off Drainage";
    const val = Number(swb.on_drainage_line ?? null);
    if (!isNaN(val) && swb.on_drainage_line !== null && swb.on_drainage_line !== undefined) {
      return val === 1 ? "On Drainage" : "Off Drainage";
    }
    return "N/A";
  }

  if (filterName === "surface_water_trend") {
    // Use pre-computed if available
    if (swb.wbTrend) {
      return swb.wbTrend.charAt(0).toUpperCase() + swb.wbTrend.slice(1);
    }
    // Compute from raw area_ fields using Mann-Kendall
    const areas = Object.keys(swb)
      .filter(k => k.startsWith("area_") && k !== "area_ored")
      .sort()
      .map(k => Number(swb[k] ?? 0));
    if (areas.length < 2) return "N/A";
    let S = 0;
    for (let i = 0; i < areas.length - 1; i++) {
      for (let j = i + 1; j < areas.length; j++) {
        if (areas[j] > areas[i]) S++;
        else if (areas[j] < areas[i]) S--;
      }
    }
    if (S > 0) return "Positive";
    if (S < 0) return "Negative";
    return "Steady";
  }

  if (filterName === "waterbody_size") {
    // Use pre-computed if available
    if (swb.wbSizeCategory) {
      const map = {
        small: "Small (<1 ha)",
        medium: "Medium (1–5 ha)",
        large: "Large (5–10 ha)",
        veryLarge: "Very Large (>10 ha)",
      };
      return map[swb.wbSizeCategory] || "N/A";
    }
    // Compute from raw area
    const area = Number(swb.area_ored ?? swb.AREA_HA ?? swb.area ?? swb.Area ?? 0);
    if (isNaN(area)) return "N/A";
    if (area < 1) return "Small (<1 ha)";
    if (area < 5) return "Medium (1–5 ha)";
    if (area < 10) return "Large (5–10 ha)";
    return "Very Large (>10 ha)";
  }

  return "N/A";
};

  const downloadPDF = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const { mwsData, villageData } = generateSelectionTableData();

      let mapImageData = null;
      try {
        const map = mapRef.current;
        if (map) {
          mapImageData = await new Promise((resolve) => {
            map.render();
            map.once('rendercomplete', () => {
              try {
                const mapCanvas = document.createElement('canvas');
                const size = map.getSize();
                mapCanvas.width = size[0];
                mapCanvas.height = size[1];
                const ctx = mapCanvas.getContext('2d');
                const viewport = map.getViewport();
                viewport.querySelectorAll('canvas').forEach((layerCanvas) => {
                  if (layerCanvas.width > 0) {
                    const parentOpacity = layerCanvas.parentNode.style.opacity;
                    ctx.globalAlpha = parentOpacity !== "" ? parseFloat(parentOpacity) : 1;
                    const transform = layerCanvas.style.transform;
                    if (transform) {
                      const matrix = transform.match(/^matrix\(([^)]*)\)$/)?.[1].split(',').map(Number);
                      if (matrix) ctx.setTransform(...matrix);
                    } else {
                      ctx.setTransform(1, 0, 0, 1, 0, 0);
                    }
                    ctx.drawImage(layerCanvas, 0, 0);
                  }
                });
                ctx.globalAlpha = 1;
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                resolve(mapCanvas.toDataURL('image/jpeg', 0.9));
              } catch (e) {
                console.warn('Canvas composite failed:', e);
                resolve(null);
              }
            });
            map.renderSync();
          });
        }
      } catch (mapErr) {
        console.warn('Map capture failed:', mapErr);
      }

      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
      const pageW = doc.internal.pageSize.width;

      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(30, 30, 30);
      doc.text('KYL Dashboard Report', 14, 14);
      doc.setDrawColor(180, 180, 180);
      doc.line(14, 17, pageW - 14, 17);
      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(140, 140, 140);
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageW - 14, 14, { align: 'right' });

      let yPos = 23;
      doc.setFillColor(245, 247, 255);
      doc.roundedRect(14, yPos - 3, pageW - 28, 14, 2, 2, 'F');
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(60, 60, 60);
      doc.text('Location:', 18, yPos + 4);
      doc.setFont('helvetica', 'normal');
      doc.text(`State: ${state?.label || 'N/A'}`, 50, yPos + 4);
      doc.text(`District: ${district?.label || 'N/A'}`, 110, yPos + 4);
      doc.text(`Block / Tehsil: ${block?.label || 'N/A'}`, 185, yPos + 4);
      yPos += 18;

      const selectedFilters = getFormattedSelectedFilters();
      const selectedPatterns = getFormattedSelectedPatterns();

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(30, 30, 120);
      doc.text('Selected Filters / Indicators', 14, yPos);
      yPos += 2;

      if (selectedFilters.length > 0) {
        autoTable(doc, {
          startY: yPos,
          head: [['#', 'Filter Name', 'Value(s)']],
          body: selectedFilters.map((f, i) => [i + 1, f.filterName || f.name || '', (f.values || []).join(', ')]),
          theme: 'grid',
          headStyles: { fillColor: [63, 81, 181], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          columnStyles: { 0: { cellWidth: 12, halign: 'center' }, 1: { cellWidth: 70 } },
          margin: { left: 14, right: 14 },
        });
        yPos = doc.lastAutoTable.finalY + 4;
      } else {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(160, 160, 160);
        doc.text('No filters selected.', 18, yPos + 4);
        yPos += 10;
      }

      if (selectedPatterns.length > 0) {
        autoTable(doc, {
          startY: yPos,
          head: [['#', 'Pattern']],
          body: selectedPatterns.map((p, i) => [i + 1, p.category || p.patternName || '']),
          theme: 'grid',
          headStyles: { fillColor: [76, 175, 80], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          columnStyles: { 0: { cellWidth: 12, halign: 'center' } },
          margin: { left: 14, right: 14 },
        });
        yPos = doc.lastAutoTable.finalY + 4;
      }

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(30, 30, 30);
      doc.text('Map View', 14, yPos + 6);
      yPos += 8;

      if (mapImageData) {
        const imgProps = doc.getImageProperties(mapImageData);
        const maxW = pageW - 28;
        const remainingH = doc.internal.pageSize.height - yPos - 20;
        const maxH = Math.max(remainingH, 60);
        const ratio = Math.min(maxW / imgProps.width, maxH / imgProps.height);
        const imgW = imgProps.width * ratio;
        const imgH = imgProps.height * ratio;
        if (yPos + imgH > doc.internal.pageSize.height - 15) { doc.addPage(); yPos = 20; }
        doc.addImage(mapImageData, 'JPEG', 14, yPos, imgW, imgH);
        yPos += imgH + 8;
      } else {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(160, 160, 160);
        doc.text('(Map screenshot could not be captured)', 14, yPos + 4);
        yPos += 12;
      }

      if (mwsData.length > 0 || villageData.length > 0) {
        if (yPos > doc.internal.pageSize.height - 50) { doc.addPage(); yPos = 20; }
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(30, 30, 30);
        doc.text(
          `Selected Items: ${mwsData.length + villageData.length} total  (MWS: ${mwsData.length} | Villages: ${villageData.length})`,
          14, yPos
        );
        yPos += 4;

        if (mwsData.length > 0) {
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(37, 99, 235);
          doc.text(`Micro-watersheds (${mwsData.length})`, 14, yPos + 6);
          autoTable(doc, {
            startY: yPos + 8,
            head: [['#', 'Micro-watershed ID', 'Intersecting Villages', 'Intersecting Waterbodies']],
            body: mwsData.map((item, i) => {
              const mwsGroup = mwsVillageIntersections.find(g => g.mwsId === item.name);
              const villagesStr = mwsGroup ? mwsGroup.villages.map(v => `${v.villageName || 'Unknown'} (${v.villageId})`).join(', ') : 'None';
              const swbStr = mwsGroup && mwsGroup.waterbodies?.length > 0
                ? mwsGroup.waterbodies.map(swb => swb.swbName ? `${swb.swbName} (${swb.swbId})` : swb.swbId).join(', ')
                : 'None';
              return [i + 1, item.name, villagesStr, swbStr];
            }),
            theme: 'grid',
            headStyles: { fillColor: [37, 99, 235], fontSize: 9 },
            bodyStyles: { fontSize: 8 },
            columnStyles: { 0: { cellWidth: 12, halign: 'center' }, 1: { cellWidth: 40 }, 2: { cellWidth: 70 }, 3: { cellWidth: 'auto' } },
            margin: { left: 14, right: 14 },
          });
          yPos = doc.lastAutoTable.finalY + 8;
        }

        if (villageData.length > 0) {
          if (yPos > doc.internal.pageSize.height - 40) { doc.addPage(); yPos = 20; }
          doc.setFontSize(10);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(22, 163, 74);
          doc.text(`Villages (${villageData.length})`, 14, yPos);
          autoTable(doc, {
            startY: yPos + 4,
            head: [['S.No.', 'Village ID', 'Village Name']],
            body: villageData.map((item, i) => [i + 1, item.villageId, item.villageName]),
            theme: 'striped',
            headStyles: { fillColor: [22, 163, 74], fontSize: 9 },
            bodyStyles: { fontSize: 8 },
            columnStyles: { 0: { cellWidth: 15, halign: 'center' }, 1: { cellWidth: 35 }, 2: { cellWidth: 'auto' } },
            margin: { left: 14, right: 14 },
          });
          yPos = doc.lastAutoTable.finalY + 8;
        }
      }

      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(`Page ${i} of ${pageCount}`, pageW / 2, doc.internal.pageSize.height - 8, { align: 'center' });
      }

      doc.save(`kyl_report_${transformName(state?.label) || 'report'}_${new Date().toISOString().split('T')[0]}.pdf`);
    } catch (error) {
      console.error('PDF generation error:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  const downloadExcel = () => {
    try {
      const { mwsData, villageData } = generateSelectionTableData();
      const selectedFilters = getFormattedSelectedFilters();

      const mwsFilters = [];
      const villageFilters = [];
      const waterbodyFilters = [];

      selectedFilters.forEach(f => {
        const namespace = FILTER_BY_NAME.get(f.name)?.namespace;
        if (namespace === "MWS") mwsFilters.push(f);
        if (namespace === "Village") villageFilters.push(f);
        if (namespace === "Waterbody") waterbodyFilters.push(f);
      });

      const getLabelFromValue = (filterName, value) => {
        const filterObj = FILTER_BY_NAME.get(filterName);
        if (filterObj && filterObj.type === 1) {
          const match = filterObj.values.find(v => String(v.value) === String(value));
          return match ? match.label : value;
        }
        return value;
      };

      // Sheet 0 — Selected Filters
      const sheet0Data = [
        {
          "S.NO": "",
          "INDICATOR NAME": "State",
          "SELECTED VALUES": state?.label || "N/A",
        },
        {
          "S.NO": "",
          "INDICATOR NAME": "District",
          "SELECTED VALUES": district?.label || "N/A",
        },
        {
          "S.NO": "",
          "INDICATOR NAME": "Block / Tehsil",
          "SELECTED VALUES": block?.label || "N/A",
        },
        {
          "S.NO": "",
          "INDICATOR NAME": "",
          "SELECTED VALUES": "",
        }, // blank separator row
        ...selectedFilters.map((f, i) => ({
          "S.NO": i + 1,
          "INDICATOR NAME": f.filterName || f.name,
          "SELECTED VALUES": (f.values || []).join(", "),
        })),
      ];

      // Sheet 1 — Selected MWS
      const sheet1Data = mwsData.map(item => {
        const row = { "MICRO-WATERSHED ID": item.name };
        if (dataJson && Array.isArray(dataJson)) {
          const mRecord = dataJson.find(m => String(m.mws_id) === String(item.name));
          if (mRecord) {
            mwsFilters.forEach(f => {
              let val = mRecord[f.name];
              if (val === undefined || val === null) val = "N/A";
              else {
                val = getLabelFromValue(f.name, val);
                if (typeof val === "number") val = Number(val.toFixed(3));
              }
              row[(f.filterName || f.name).toUpperCase()] = val;
            });
          }
        }
        return row;
      });

      // Sheet 2 — Selected Villages
      const sheet2Data = villageData.map(item => {
        const row = { "VILLAGE ID": item.villageId, "VILLAGE NAME": item.villageName };
        if (villageJson && Array.isArray(villageJson)) {
          const vRecord = villageJson.find(v => String(v.village_id || v.vill_ID) === String(item.villageId));
          if (vRecord) {
            villageFilters.forEach(f => {
              let val = vRecord[f.name];
              if (val === undefined || val === null) val = "N/A";
              else {
                val = getLabelFromValue(f.name, val);
                if (typeof val === "number") val = Number(val.toFixed(3));
              }
              row[(f.filterName || f.name).toUpperCase()] = val;
            });
          }
        }
        return row;
      });

      // Sheet 3 — Selected Waterbodies
      const uniqueSwbs = new Map();

      if (waterbodyFilters.length > 0 && showWB) {
        // selectedWaterbodyData already has all computed props and already accounts
        // for the MWS geometric intersection (see applyWaterbodyFilters in
        // kyl_dashboard.jsx), so use it directly for both the WB-only and MWS+WB cases.
        selectedWaterbodyData.forEach(swb => {
          if (!uniqueSwbs.has(swb.swbId) && (!selectedWaterbodyIds || selectedWaterbodyIds.has(String(swb.swbId)))) {
            const row = {
              "SWB ID": swb.swbId,
              "WATERBODY NAME": swb.swbName || "Unknown",
              "LATITUDE": swb.latitude || 0,
              "LONGITUDE": swb.longitude || 0,
            };
            waterbodyFilters.forEach(f => {
              row[(f.filterName || f.name).toUpperCase()] = getWBDisplayValue(f.name, swb);
            });
            uniqueSwbs.set(swb.swbId, row);
          }
        });
      }

      const sheet3Data = Array.from(uniqueSwbs.values());

      // Sheet 4 — MWS-Village Intersections
      const hasVillagePattern = getFormattedSelectedPatterns().some(p => p.level);

      const sheet4Data = [];
      mwsVillageIntersections.forEach(group => {
        group.villages.forEach(v => {
          const villageIdStr = String(v.villageId);

          let isSelected = false;
          if (villageFilters.length > 0 || hasVillagePattern) {
            if (selectedVillages instanceof Set) {
              isSelected =
                selectedVillages.has(villageIdStr) ||
                selectedVillages.has(Number(v.villageId));
            } else if (Array.isArray(selectedVillages)) {
              isSelected = selectedVillages.some(sid => String(sid) === villageIdStr);
            }
          }

          if (!isSelected) return; // skip non-matching villages

          sheet4Data.push({
            "MICRO-WATERSHED ID": group.mwsId,
            "VILLAGE ID": villageIdStr,
            "VILLAGE NAME": v.villageName,
          });
        });
      });

      // Sheet 5 — MWS-Waterbody Intersections
      const sheet5Data = [];
      mwsVillageIntersections.forEach(group => {
        group.waterbodies.forEach(swb => {
          const swbIdStr = String(swb.swbId);

          const isFilterMatched =
            waterbodyFilters.length > 0 &&
            selectedWaterbodyIds &&
            selectedWaterbodyIds.has(swbIdStr);

          if (!isFilterMatched) return;

          sheet5Data.push({
            "MICRO-WATERSHED ID": group.mwsId,
            "SWB ID": swbIdStr,
            "WATERBODY NAME": swb.swbName || "",
          });
        });
      });

      const workbook = XLSX.utils.book_new();
      const boldStyle = { font: { bold: true } };

      const activeSheets = [
        { sheet: XLSX.utils.json_to_sheet(sheet0Data), name: "Selected Filters", width: [{ wch: 8 }, { wch: 40 }, { wch: 60 }] },
      ];

      const mWidths = [{ wch: 25 }];
      mwsFilters.forEach(() => mWidths.push({ wch: 20 }));
      activeSheets.push({ sheet: XLSX.utils.json_to_sheet(sheet1Data), name: "Matching MWS", width: mWidths });

      if (villageFilters.length > 0) {
        const vWidths = [{ wch: 25 }, { wch: 40 }];
        villageFilters.forEach(() => vWidths.push({ wch: 20 }));
        activeSheets.push({ sheet: XLSX.utils.json_to_sheet(sheet2Data), name: "Matching Villages", width: vWidths });
      }

      if (sheet3Data.length > 0) {
        // All WB filter columns included — no skip needed since getWBDisplayValue handles all
        const wbWidths = [{ wch: 25 }, { wch: 40 }, { wch: 18 }, { wch: 18 }];
        waterbodyFilters.forEach(() => wbWidths.push({ wch: 22 }));
        activeSheets.push({ sheet: XLSX.utils.json_to_sheet(sheet3Data), name: "Matching Waterbodies", width: wbWidths });
      }

      activeSheets.push({ sheet: XLSX.utils.json_to_sheet(sheet4Data), name: "MWS-Village Intersects", width: [{ wch: 25 }, { wch: 25 }, { wch: 40 }] });
      activeSheets.push({ sheet: XLSX.utils.json_to_sheet(sheet5Data), name: "MWS-Waterbody Intersects", width: [{ wch: 25 }, { wch: 25 }, { wch: 40 }] });

      const greenStyle = {
        fill: { patternType: "solid", fgColor: { rgb: "10B981" } }, // emerald-500
        font: { color: { rgb: "FFFFFF" }, bold: true },
      };

      activeSheets.forEach(({ sheet, name, width, highlightRows }) => {
        if (sheet["!ref"]) {
          const range = XLSX.utils.decode_range(sheet["!ref"]);
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const addr = XLSX.utils.encode_cell({ r: 0, c: C });
            if (sheet[addr]) sheet[addr].s = boldStyle;
          }

          // Highlight filter-matched waterbody rows in green
          if (highlightRows && highlightRows.length > 0) {
            highlightRows.forEach(dataRowIdx => {
              const r = dataRowIdx + 1; // +1 because row 0 is the header
              for (let C = range.s.c; C <= range.e.c; ++C) {
                const addr = XLSX.utils.encode_cell({ r, c: C });
                if (sheet[addr]) sheet[addr].s = greenStyle;
              }
            });
          }
        }
        sheet["!cols"] = width;
        XLSX.utils.book_append_sheet(workbook, sheet, name);
      });

      XLSX.writeFile(workbook, `kyl_selection_report_${new Date().toISOString().split('T')[0]}_${transformName(block?.label)}.xlsx`);
    } catch (error) {
      console.error('Excel generation error:', error);
      alert('Error generating Excel file.');
    }
  };


  // ─── Selection Popup ─────────────────────────────────────────────────────
  const SelectionPopup = () => {
    const [activeTab, setActiveTab] = React.useState('mws');
    if (!showSelectionPopup) return null;

    const { mwsData, villageData } = generateSelectionTableData();
    const seenVillageIds = new Set();
    const mwsCount = manualSelectedMWS?.length > 0 ? manualSelectedMWS.length : mwsData.length;


    const selectedFiltersCount = getFormattedSelectedFilters();
    const selectedPatternsCount = getFormattedSelectedPatterns();


    const hasVillageFilter = selectedFiltersCount.some(f => FILTER_BY_NAME.get(f.name)?.namespace === "Village");
    const hasWaterbodyFilter = selectedFiltersCount.some(f => FILTER_BY_NAME.get(f.name)?.namespace === "Waterbody");

    const hasVillagePattern = selectedPatternsCount.some(p => p.level);

    const uniqueSwbs = new Map();

    if (hasWaterbodyFilter && showWB) {
      // selectedWaterbodyData/selectedWaterbodyIds already account for the MWS
      // geometric intersection (when an MWS filter is also active) — see
      // applyWaterbodyFilters in kyl_dashboard.jsx. Re-intersecting here against
      // the precomputed mws_intersect_swb index caused it to disagree with what's
      // actually shown on the map, so just use the already-matched data directly.
      selectedWaterbodyData.forEach(swb => {
        if (!uniqueSwbs.has(swb.swbId) && (!selectedWaterbodyIds || selectedWaterbodyIds.has(String(swb.swbId)))) {
          uniqueSwbs.set(swb.swbId, swb);
        }
      });
    }

    const waterbodyData = Array.from(uniqueSwbs.values());

    // totalItems after waterbodyData is declared
    const totalItems = mwsData.length + villageData.length + waterbodyData.length;

    const sheet1Count = mwsCount;
    const sheet2Count = villageData.length;
    const sheet3Count = waterbodyData.length;
    // const sheet4Count = mwsVillageIntersections.reduce((acc, curr) => acc + (curr.villages?.length || 0), 0);
    // const sheet5Count = mwsVillageIntersections.reduce((acc, curr) => acc + (curr.waterbodies?.length || 0), 0);
    const sheet4Count =
  manualSelectedMWS?.length > 0
    ? manualSelectionDetails.reduce(
        (acc, curr) => acc + (curr.villages?.length || 0),
        0
      )
    : mwsVillageIntersections.reduce(
        (acc, curr) => acc + (curr.villages?.length || 0),
        0
      );

const sheet5Count =
  manualSelectedMWS?.length > 0
    ? manualSelectionDetails.reduce(
        (acc, curr) => acc + (curr.waterbodies?.length || 0),
        0
      )
    : mwsVillageIntersections.reduce(
        (acc, curr) => acc + (curr.waterbodies?.length || 0),
        0
      );

    // const tabs = [
    //   { key: 'mws', label: 'Watersheds', count: mwsCount, always: true, color: 'blue' },
    //   { key: 'villages', label: 'Villages', count: villageData.length, always: false, show: hasVillageFilter, color: 'green' },
    //   { key: 'waterbodies', label: 'Waterbodies', count: waterbodyData.length, always: false, show: hasWaterbodyFilter, color: 'cyan' },
    // ];

    const tabs = [
  {
    key: "mws",
    label: "Watersheds",
    count: mwsCount,
    always: true,
    color: "blue",
  },
  {
    key: "villages",
    label: "Villages",
    count: manualSelectedMWS?.length > 0 ? sheet4Count : villageData.length,
    always: false,
    show: hasVillageFilter,
    color: "green",
  },
  {
    key: "waterbodies",
    label: "Waterbodies",
    count: manualSelectedMWS?.length > 0 ? sheet5Count : waterbodyData.length,
    always: false,
    show: hasWaterbodyFilter,
    color: "cyan",
  },
];

    const currentMwsData = manualSelectedMWS?.length > 0 ? manualSelectionDetails.map((m) => ({
        id: m.mwsId,
        name: m.mwsId,
      }))
    : mwsData;

    return (
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center z-50"
        onClick={() => setShowSelectionPopup(false)}
      >
        <div
          className="bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[92vh] overflow-hidden flex flex-col mx-4"
          onClick={e => e.stopPropagation()}
        >
          {/* ── Header ── */}
          <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gradient-to-r from-slate-50 to-white flex-shrink-0">
            <div>
              <h3 className="text-base font-bold text-gray-800 tracking-tight">Selection Details</h3>
              <p className="text-xs text-gray-400 mt-0.5">{totalItems} items across {mwsCount} watersheds</p>
            </div>

            <div className="flex items-center gap-2">
              {/* Tabs */}
              <div className="flex gap-1 bg-gray-100 p-1 rounded-lg">
                {tabs.filter(t => t.always || t.show).map(tab => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`px-3 py-1.5 text-xs font-semibold rounded-md transition-all duration-150 flex items-center gap-1.5 ${
                      activeTab === tab.key
                        ? 'bg-white text-gray-800 shadow-sm'
                        : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    {tab.label}
                    <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                      activeTab === tab.key ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-600'
                    }`}>{tab.count}</span>
                  </button>
                ))}
              </div>

              {/* Download buttons — replace the existing PDF + Excel block */}
              <button
                onClick={downloadPDF}
                disabled={isDownloading}
                className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border transition-all ${
                  isDownloading
                    ? 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
                    : 'border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300'
                }`}
              >
                {isDownloading ? (
                  <><Loader2 className="w-3 h-3 animate-spin" /><span>Generating…</span></>
                ) : (
                  <><FileText className="w-3 h-3" /><span>PDF</span></>
                )}
              </button>

              <button
                onClick={downloadExcel}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border border-emerald-200 text-emerald-600 hover:bg-emerald-50 hover:border-emerald-300 transition-all"
              >
                <FileSpreadsheet className="w-3 h-3" />
                <span>Excel</span>
              </button>

              {/* GeoJSON / KML export */}
              <div className="relative group">
                <button
                  disabled={isExportingGeo}
                  className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg border transition-all ${
                    isExportingGeo
                      ? 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
                      : 'border-amber-200 text-amber-600 hover:bg-amber-50 hover:border-amber-300'
                  }`}
                >
                  {isExportingGeo ? (
                    <><Loader2 className="w-3 h-3 animate-spin" /><span>{geoExportFormat === 'kml' ? 'KML…' : 'GeoJSON…'}</span></>
                  ) : (
                    <>
                      <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                      <span>Geo ▾</span>
                    </>
                  )}
                </button>

                {/* Dropdown */}
                {!isExportingGeo && (
                  <div className="absolute right-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-1 w-32 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
                    <button
                      onClick={() => exportBoundaries('geojson')}
                      className="w-full text-left px-3 py-1.5 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-700 transition-colors"
                    >
                      GeoJSON
                    </button>
                    <button
                      onClick={() => exportBoundaries('kml')}
                      className="w-full text-left px-3 py-1.5 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-700 transition-colors"
                    >
                      KML (Google Earth)
                    </button>
                  </div>
                )}
              </div>

              <button
                onClick={() => setShowSelectionPopup(false)}
                className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* ── Tab Content ── */}
          <div className="overflow-y-auto flex-1 p-4 bg-gray-50/50">

            {/* MWS Tab */}
            {activeTab === 'mws' && (
              
              currentMwsData.length > 0 ? (
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="bg-gradient-to-r from-purple-600 to-purple-500 text-white">
                        <th className="text-left px-4 py-2.5 font-semibold w-8">#</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Watershed ID</th>
                        <th className="text-center px-4 py-2.5 font-semibold">Report</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Intersecting Villages</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Intersecting Waterbodies</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {currentMwsData.map((item, i) => {
                        const mwsGroup = mwsVillageIntersections.find(g => g.mwsId === item.name);
                        return (
                          <tr key={item.id} className="hover:bg-blue-50/30 align-top transition-colors">
                            <td className="px-4 py-2.5 text-gray-400 font-mono">{i + 1}</td>
                            <td className="px-4 py-2.5">
                              {/* <span className="font-mono text-gray-800 bg-gray-100 px-2 py-0.5 rounded text-[11px]">{item.name}</span> */}
                              <span
                                className={`font-mono px-2 py-0.5 rounded text-[11px] ${
                                  manualSelectedMWS?.length > 0
                                    ? "bg-emerald-500 text-white"
                                    : "bg-gray-100 text-gray-800"
                                }`}
                              >
                                {item.name}
                              </span>
                            </td>
                            <td className="px-4 py-2.5 text-center">
                              <a
                                href={`https://geoserver.core-stack.org/api/v1/generate_mws_report/?state=${transformName(state?.label)}&district=${transformName(district?.label)}&block=${transformName(block?.label)}&uid=${item.name}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1 text-indigo-600 hover:text-indigo-800 font-semibold"
                              >
                                View <ChevronRight className="w-3 h-3" />
                              </a>
                            </td>
                            <td className="px-4 py-2.5">
                              {mwsGroup && mwsGroup.villages.length > 0 ? (
                                <div className="flex flex-wrap gap-1">
                                  {
                                    (
                                      manualSelectedMWS?.length > 0
                                        ? (manualSelectionDetails.find(
                                            m => String(m.mwsId) === String(item.name)
                                          )?.villages || [])
                                        : mwsGroup.villages
                                    )
                                    .filter(v => {
                                    const id = String(v.villageId);
                                    if (seenVillageIds.has(id)) return false;
                                    seenVillageIds.add(id);
                                    return true;
                                  }).map(v => {
                                    const villageIdStr = String(v.villageId);
                                    let isSelected = false;
                                    if (hasVillageFilter || hasVillagePattern) {
                                      if (selectedVillages instanceof Set) {
                                        isSelected = selectedVillages.has(villageIdStr) || selectedVillages.has(Number(v.villageId));
                                      } else if (Array.isArray(selectedVillages)) {
                                        isSelected = selectedVillages.some(sid => String(sid) === villageIdStr);
                                      }
                                    }
                                    return (
                                      <a
                                        key={v.villageId}
                                        href={buildVillageReportUrl(v.villageId)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={`${isSelected ? 'Matches filter' : 'Intersects'} | ID: ${v.villageId} — open village report`}
                                       className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium border transition-colors ${
                                        isSelected
                                          ? "bg-emerald-500 border-emerald-600 text-white hover:bg-emerald-600"
                                          : "bg-violet-50 border-violet-200 text-violet-700 hover:bg-violet-100"
                                      }`}
                                      >
                                        {v.villageName || 'Unknown'}
                                        <span className="opacity-70 font-mono text-[9px]">({v.villageId})</span>
                                      </a>
                                    );
                                  })}
                                </div>
                              ) : (
                                <span className="text-gray-300 italic text-[10px]">No intersections</span>
                              )}
                            </td>
                            <td className="px-4 py-2.5">
                              {(() => {
                                // Directly read from dataJson — most reliable source,
                                // doesn't depend on WB layer being loaded or selectedWaterbodyIds timing
                                const mwsRecord = dataJson?.find(d => d.mws_id === item.name);
                                const allSwbs = mwsRecord?.mws_intersect_swb || [];

                                if (allSwbs.length === 0) {
                                  return <span className="text-gray-300 italic text-[10px]">None</span>;
                                }

                                return (
                                  <div className="flex flex-wrap gap-1">
                                    {allSwbs.map(swb => {
                                      const swbIdStr = typeof swb === 'object' ? String(swb.swbId) : String(swb);
                                      const swbName = typeof swb === 'object' ? (swb.swbName || '') : '';
                                      // Green if WB filter is active and this WB matched it
                                      // Blue if just a structural intersection
                                      const isFilterMatched = hasWaterbodyFilter &&
                                        selectedWaterbodyIds &&
                                        selectedWaterbodyIds.has(swbIdStr);

                                      return (
                                        <span
                                          key={swbIdStr}
                                          title={`${isFilterMatched ? 'Matches filter' : 'Structural intersection'} | ID: ${swbIdStr}`}
                                          className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium border transition-colors ${
                                            isFilterMatched
                                              ? "bg-emerald-500 border-emerald-600 text-white"
                                              : "bg-sky-50 border-sky-200 text-sky-700"
                                          }`}
                                        >
                                          {swbName ? `${swbName} (${swbIdStr})` : swbIdStr}
                                        </span>
                                      );
                                    })}
                                  </div>
                                );
                              })()}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                  <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                    <Table className="w-5 h-5" />
                  </div>
                  <p className="text-sm font-medium">No micro-watersheds selected</p>
                  <p className="text-xs mt-1">Apply a filter to see results here</p>
                </div>
              )
            )}

            {/* Villages Tab */}
            {activeTab === 'villages' && (
              villageData.length > 0 ? (
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="bg-gradient-to-r from-emerald-600 to-emerald-500 text-white">
                        <th className="text-left px-4 py-2.5 font-semibold w-8">#</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Village ID</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Village Name</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {villageData.map((item, i) => (
                        <tr key={item.id} className="hover:bg-emerald-50/30 transition-colors">
                          <td className="px-4 py-2.5 text-gray-400">{i + 1}</td>
                          <td className="px-4 py-2.5">
                            <span className="font-mono text-gray-700 bg-gray-100 px-2 py-0.5 rounded text-[11px]">{item.villageId}</span>
                          </td>
                          <td className="px-4 py-2.5 text-gray-800 font-medium">{item.villageName}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                  <p className="text-sm font-medium">No filter-matched villages found</p>
                </div>
              )
            )}

            {/* Waterbodies Tab */}
            {activeTab === 'waterbodies' && (
              waterbodyData.length > 0 ? (
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="bg-gradient-to-r from-cyan-600 to-cyan-500 text-white">
                        <th className="text-left px-4 py-2.5 font-semibold w-8">#</th>
                        <th className="text-left px-4 py-2.5 font-semibold">SWB ID</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Waterbody Name</th>
                        <th className="text-left px-4 py-2.5 font-semibold">Coordinates</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {waterbodyData.map((swb, i) => (
                        <tr key={swb.swbId} className="hover:bg-cyan-50/30 transition-colors">
                          <td className="px-4 py-2.5 text-gray-400">{i + 1}</td>
                          <td className="px-4 py-2.5">
                            <span className="font-mono text-gray-700 bg-gray-100 px-2 py-0.5 rounded text-[11px]">{swb.swbId}</span>
                          </td>
                          <td className="px-4 py-2.5 text-gray-800 font-medium">{swb.swbName || 'Unknown'}</td>
                          <td className="px-4 py-2.5 font-mono text-gray-400 text-[10px]">
                            {swb.latitude?.toFixed(5)}, {swb.longitude?.toFixed(5)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                  <p className="text-sm font-medium">No waterbodies in selection</p>
                </div>
              )
            )}
          </div>

          {/* ── Footer ── */}
          <div className="px-6 py-3 border-t border-gray-100 bg-white flex justify-between items-center flex-shrink-0">
            {/* Excel sheet counts */}
            <div className="flex items-center gap-3">
              {[
                { label: "MWS", count: sheet1Count, color: "text-blue-600" },
                { label: "Villages", count: sheet2Count, color: "text-emerald-600", show: hasVillageFilter },
                { label: "Waterbodies", count: sheet3Count, color: "text-cyan-600", show: hasWaterbodyFilter },
                { label: "MWS ∩ Villages", count: sheet4Count, color: "text-violet-600" },
                { label: "MWS ∩ Waterbodies", count: sheet5Count, color: "text-indigo-600" },
              ].filter(s => s.show !== false).map((stat, i, arr) => (
                <React.Fragment key={stat.label}>
                  <div className="flex flex-col items-center">
                    <span className="text-[9px] uppercase text-gray-400 font-bold tracking-widest leading-none mb-0.5">{stat.label}</span>
                    <span className={`${stat.color} font-bold text-base leading-none`}>{stat.count}</span>
                  </div>
                  {i < arr.length - 1 && <div className="w-px h-6 bg-gray-200" />}
                </React.Fragment>
              ))}
            </div>

            <button
              onClick={() => setShowSelectionPopup(false)}
              className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold rounded-lg transition-colors shadow-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleStewardProfileClick = (steward) => {
    if (!steward) return;

    const organizationId = steward.organization?.id;
    const facilitatorSlug = steward.facilitator_name
    ?.replace(/[().]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();

    window.open(
      `/landscape-stewardship/steward-view/${organizationId}/${facilitatorSlug}` +
        `?stateId=${encodeURIComponent(state?.state_id ?? "")}` +
        `&stateName=${encodeURIComponent(state?.label ?? "")}` +
        `&districtId=${encodeURIComponent(district?.district_id ?? "")}` +
        `&districtName=${encodeURIComponent(district?.label ?? "")}`,
      "_blank"
    );
  
  };

  // ─── Shared section header component ─────────────────────────────────────
  const SectionHeader = ({ title, count, action }) => (
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <span className="text-xs font-semibold text-gray-700">{title}</span>
        {count !== undefined && (
          <span className="text-[10px] font-bold bg-indigo-100 text-indigo-600 px-1.5 py-0.5 rounded-full">{count}</span>
        )}
      </div>
      {action}
    </div>
  );

  return (
    <div className="w-[320px] shrink-0 h-full flex flex-col gap-2 overflow-y-auto pr-1 custom-scrollbar">
      <SelectionPopup />

      {/* Universal Back Button */}
      {showBothPanels && (
        <div className="bg-white rounded-xl border border-gray-100 p-3 shadow-sm">
          <button
            onClick={handleUniversalBack}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Map
          </button>
        </div>
      )}

      {selectedMWSProfile ? (
      <KYLMWSProfilePanel
          mwsData={selectedMWSProfile}
          onBack={() => {
            onResetMWS();
            setSelectedPlanProfile(null);
            setSelectedStewardProfile(null);
          }}
          hideBackButton={showBothPanels}
          selectionMode={selectionMode}
          selectedMWS={manualSelectedMWS}
          setSelectionMode={setSelectionMode}
          onResetMWS={onResetMWS}
          onResetSelection={onResetMWSSelection} 
          onRemoveMWS={handleRemoveMWS}
          onOpenSelection={() => setShowSelectionPopup(true)}
          intersectingVillages={displayVillages}  
      />

      ) : null}

      {selectedWaterbodyProfile && (
        <KYLWaterbodyPanel waterbody={selectedWaterbodyProfile} onBack={onResetWaterbody} hideBackButton={showBothPanels} />
      )}

      {selectedPlanProfile && (
        <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">

          {/* Header */}
          <div className="flex items-start gap-3 mb-5">
            <div className="flex-1 flex items-center gap-2">
              <h2 className="text-lg text-indigo-600 truncate">
                {selectedPlanProfile.plan}
              </h2>
            </div>
          </div>
          {/* Information Card */}
          <div className="rounded-xl border border-gray-200 bg-gray-50 divide-y">

            <div className="flex justify-between items-center px-4 py-3">
              <span className="text-sm text-gray-500">Village</span>
              <span className="text-sm font-semibold text-gray-800">
                {selectedPlanProfile.village_name || "--"}
              </span>
            </div>

            <div className="flex justify-between items-center px-4 py-3">
              <span className="text-sm text-gray-500">Steward</span>
              <span className="text-sm font-semibold text-gray-800">
                {selectedPlanProfile.facilitator_name || "--"}
              </span>
            </div>

            <div className="flex justify-between items-center px-4 py-3">
              <span className="text-sm text-gray-500">Organization</span>
              <span className="text-sm font-semibold text-gray-800">
                {selectedPlanProfile.organization_name || "--"}
              </span>
            </div>

          </div>

          {/* View DPR Button */}
      {selectedPlanProfile?.is_dpr_reviewed && (
        <button
          className="flex items-center gap-2 text-indigo-600 hover:text-indigo-700 mb-2 text-sm mt-4"
          onClick={() => {
            window.open(
              `/landscape-stewardship/plan-view?id=${selectedPlanProfile.id}` +
              `&completed=${!!selectedPlanProfile.is_completed}` +
              `&dpr_reviewed=${!!selectedPlanProfile.is_dpr_reviewed}` +
              `&dpr_generated=${!!selectedPlanProfile.is_dpr_generated}` +
              `&dpr_approved=${!!selectedPlanProfile.is_dpr_approved}` +
              `&stateId=${encodeURIComponent(state?.state_id ?? "")}&stateName=${encodeURIComponent(state?.label ?? "")}` +
              `&districtId=${encodeURIComponent(district?.district_id ?? "")}&districtName=${encodeURIComponent(district?.label ?? "")}`,
              "_blank"
            );
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14" />
            <path d="M13 5l7 7-7 7" />
          </svg>
          View DPR
        </button>
      )}

        </div>
      )}
      {selectedStewardProfile && (
        <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
         <div className="flex items-center justify-between mb-5">
          <h2
            onClick={() => handleStewardProfileClick(selectedStewardProfile)}
            className="text-lg font-semibold text-gray-900 cursor-pointer hover:text-indigo-600 hover:underline transition-colors"
          >
            {selectedStewardProfile.facilitator_name}
          </h2>

          <span className="px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 text-xs font-medium">
            {selectedStewardProfile.organization?.name || "--"}
          </span>
        </div>

          {/* Details */}
          <div className="mb-5">
            <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
              Details
            </h3>
            <div className="rounded-xl border border-gray-200 bg-gray-50 divide-y">
              <div className="flex justify-between items-center px-4 py-3">
                <span className="text-sm text-gray-500">Project</span>
                <span className="text-sm font-medium text-gray-800">
                  {selectedStewardProfile.projects?.[0]?.name || "--"}
                </span>
              </div>
            <div className="flex justify-between items-center px-4 py-3">
                <span className="text-sm text-gray-500">Total Plans</span>
                <span className="font-semibold text-gray-800">
                  {selectedStewardProfile.plan_count ?? "--"}
                </span>
              </div>
          </div>
          </div>

          {/* Assigned Plans */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
              Assigned Plans
            </h3>
            <div className="space-y-2">
              {selectedStewardProfile.plans?.map((plan) => (
                <div
                  key={plan.id}
                  className="rounded-lg border border-gray-200 bg-white px-3 py-3"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-medium text-gray-900">
                        {plan.plan}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        Village: {plan.village_name || "--"}
                      </p>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                    <span
                      className={`text-xs font-semibold ${
                        plan.is_completed
                          ? "text-green-600"
                          : "text-amber-600"
                      }`}
                    >
                      {plan.is_completed ? "Completed" : "Pending"}
                    </span>
                      {plan.is_completed && (
                        <button
                          onClick={() => {
                            window.open(
                              `/landscape-stewardship/plan-view?id=${plan.id}` +
                                `&completed=${!!plan.is_completed}` +
                                `&dpr_reviewed=${!!plan.is_dpr_reviewed}` +
                                `&dpr_generated=${!!plan.is_dpr_generated}` +
                                `&dpr_approved=${!!plan.is_dpr_approved}` +
                                `&stateId=${encodeURIComponent(state?.state_id ?? "")}` +
                                `&stateName=${encodeURIComponent(state?.label ?? "")}` +
                                `&districtId=${encodeURIComponent(district?.district_id ?? "")}` +
                                `&districtName=${encodeURIComponent(district?.label ?? "")}`,
                              "_blank"
                            );
                          }}
                          className="text-xs font-medium text-indigo-600 hover:text-indigo-700 flex items-center gap-1"
                        >
                          View DPR
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M5 12h14" />
                            <path d="M13 5l7 7-7 7" />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>

        </div>
      )}

      {!selectedMWSProfile && !selectedWaterbodyProfile && !selectedPlanProfile && !selectedStewardProfile &&(
          <div className="flex flex-col gap-2">

          {/* ── Hint banner ── */}
          <div className="bg-indigo-50 border border-indigo-100 rounded-xl px-3 py-2">
            <p className="text-[11px] text-indigo-600 font-medium">
              Click on a micro-watershed (blue outline) to view its report.
            </p>
          </div>

          {/* ── Location selector ── */}
          <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
            <div className="space-y-3">
              {[
                { label: "State", val: state, setVal: setState, data: statesData },
                { label: "District", val: district, setVal: setDistrict, data: state?.district ?? null },
                { label: "Tehsil", val: block, setVal: setBlock, data: district?.blocks ?? null },
              ].map(({ label, val, setVal, data }) => (
                <div key={label} className="flex items-center gap-3">
                  <label className="text-xs font-medium text-gray-500 w-12 shrink-0">{label}</label>
                  <SelectButton
                    currVal={val || { label: `Select ${label}` }}
                    stateData={data}
                    handleItemSelect={handleItemSelect}
                    setState={setVal}
                    className="w-full"
                  />
                </div>
              ))}
            </div>

            {block && (
              <div className="mt-4 flex flex-col gap-2">
                <div className="grid grid-cols-2 gap-2">
                <button
                onClick={handleTehsilReport}
                disabled={isLoading || !mwsLayerRef?.current}
                className={`flex items-center justify-center gap-1.5 py-2 text-xs font-semibold rounded-lg transition-colors border ${
                  (isLoading || !mwsLayerRef?.current)
                    ? 'opacity-50 cursor-not-allowed pointer-events-none bg-gray-100 text-gray-400 border-gray-200'
                    : 'text-indigo-600 bg-indigo-50 hover:bg-indigo-100 border-indigo-100'
                }`}
              >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z" />
                    </svg>
                    Tehsil Report
                  </button>

                        <button
                    onClick={toggleWaterbodies}
                    disabled={isLoading || !mwsLayerRef?.current}
                    className={`flex items-center justify-center gap-1.5 py-2 text-xs font-semibold rounded-lg transition-colors border ${
                      (isLoading || !mwsLayerRef?.current)
                        ? 'opacity-50 cursor-not-allowed pointer-events-none bg-gray-100 text-gray-400 border-gray-200'
                        : showWB
                          ? 'text-red-600 bg-red-50 hover:bg-red-100 border-red-100'
                          : 'text-indigo-600 bg-indigo-50 hover:bg-indigo-100 border-indigo-100'
                    }`}
                  >
                    {loadingWB ? (
                      <><Loader2 className="w-3.5 h-3.5 animate-spin" />Loading…</>
                    ) : showWB ? (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 2C12 2 7 8 7 12a5 5 0 0 0 8.6 3.5" />
                          <line x1="3" y1="3" x2="21" y2="21" />
                        </svg>
                        Hide Waterbodies
                      </>
                    ) : (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 2C12 2 7 8 7 12a5 5 0 0 0 10 0c0-4-5-10-5-10z" />
                        </svg>
                        Show Waterbodies
                      </>
                    )}
                  </button>
                   </div>
                <div className="grid grid-cols-2 gap-2">
                  <button
                  onClick={handlePlansClick}
                    disabled={isLoading || !mwsLayerRef?.current}
                    className={`flex items-center justify-center gap-1.5 py-2 text-xs font-semibold rounded-lg transition-colors border ${
                      (isLoading || !mwsLayerRef?.current)
                        ? "opacity-50 cursor-not-allowed pointer-events-none bg-gray-100 text-gray-400 border-gray-200"
                        : showPlans
                          ? "text-red-600 bg-red-50 hover:bg-red-100 border-red-100"
                          : "text-indigo-600 bg-indigo-50 hover:bg-indigo-100 border-indigo-100"
                    }`}
                  >
                   {showPlans ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z" />
                          <circle cx="12" cy="9" r="2.5" />
                        </svg>
                      )}

                    {showPlans ? "Hide Plans" : "Plans"}
                    </button>

                         <button
                  onClick={handleStewardsClick}
                    disabled={isLoading || !mwsLayerRef?.current}
                    className={`flex items-center justify-center gap-1.5 py-2 text-xs font-semibold rounded-lg transition-colors border ${
                      (isLoading || !mwsLayerRef?.current)
                        ? "opacity-50 cursor-not-allowed pointer-events-none bg-gray-100 text-gray-400 border-gray-200"
                        : showStewards
                          ? "text-red-600 bg-red-50 hover:bg-red-100 border-red-100"
                          : "text-indigo-600 bg-indigo-50 hover:bg-indigo-100 border-indigo-100"
                    }`}
                  >
                   {showStewards ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      <line x1="3" y1="3" x2="21" y2="21" />
                    </svg>
                      ) : (
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                      )}

                    {showStewards ? "Hide Stewards" : "Stewards"}
                    </button>

                  </div>
               

                <button
                  onClick={toggleConnectivity}
                  disabled={isLoading || !mwsLayerRef?.current}
                  className={`w-full flex items-center justify-center gap-1.5 py-2 text-xs font-semibold rounded-lg transition-colors border ${
                    (isLoading || !mwsLayerRef?.current)
                      ? 'opacity-50 cursor-not-allowed pointer-events-none bg-gray-100 text-gray-400 border-gray-200'
                      : showConnectivity
                        ? 'text-red-600 bg-red-50 hover:bg-red-100 border-red-100'
                        : 'text-indigo-600 bg-indigo-50 hover:bg-indigo-100 border-indigo-100'
                  }`}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="5" cy="12" r="2" /><circle cx="19" cy="5" r="2" /><circle cx="19" cy="19" r="2" />
                    <line x1="7" y1="12" x2="17" y2="6" /><line x1="7" y1="12" x2="17" y2="18" />
                  </svg>
                  {showConnectivity ? "Hide MWS Connectivity" : "Show MWS Connectivity"}
                </button>
              </div>
            )}
          </div>


          {/* ── Selected Indicators ── */}
          <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
            <SectionHeader
              title="Selected Indicators"
              count={getFormattedSelectedFilters().length}
              action={
                getFormattedSelectedFilters().length > 0 && (
                  <button
                    onClick={() => setShowSelectionPopup(true)}
                    className="flex items-center gap-1 px-2 py-1 text-[11px] font-semibold text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors border border-indigo-100"
                  >
                    <Table className="w-3 h-3" />
                    View Selection
                  </button>
                )
              }
            />

            {getFormattedSelectedFilters().length > 0 ? (
              <>
                <div className="max-h-[160px] overflow-y-auto pr-1 space-y-1.5">
                  {getFormattedSelectedFilters().map((filter, index) => (
                    <div key={index} className="flex items-start gap-2 bg-gray-50 rounded-lg px-3 py-2 group">
                      <div className="flex-1 min-w-0">
                        <p className="text-[11px] font-semibold text-gray-700 truncate">{filter.filterName}</p>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {filter.values.map((value, vi) => (
                            <span key={vi} className="text-[10px] bg-indigo-100 text-indigo-700 px-1.5 py-0.5 rounded-full font-medium">{value}</span>
                          ))}
                        </div>
                      </div>
                      <button
                        onClick={() => handleIndicatorRemoval(filter)}
                        className={`text-gray-300 hover:text-red-400 mt-0.5 transition-colors shrink-0 ${
                          toggleStates[filter.name] && filter.layer_store?.[0] !== "waterbody" ? "invisible" : ""
                        }`}
                      >
                        <X className="w-3.5 h-3.5" />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="mt-3 pt-3 border-t border-gray-100">
                  {selectedMWS !== null && selectedMWS.length === 0 && selectedVillages !== null && selectedVillages.size === 0 ? (
                    <p className="text-[11px] text-amber-600 bg-amber-50 px-3 py-2 rounded-lg border border-amber-100">
                      No micro-watersheds or villages match the selected filters.
                    </p>
                  ) : (
                    <div className="flex gap-2">
                      <div className="flex-1 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2 text-center">
                        <p className="text-lg font-bold text-blue-600 leading-none">{selectedMWS?.length ?? 0}</p>
                        <p className="text-[10px] text-blue-400 font-medium mt-0.5">Micro-Watershed</p>
                      </div>
                      <div className="flex-1 bg-emerald-50 border border-emerald-100 rounded-lg px-3 py-2 text-center">
                        <p className="text-lg font-bold text-emerald-600 leading-none">{selectedVillages?.size ?? 0}</p>
                        <p className="text-[10px] text-emerald-400 font-medium mt-0.5">Villages</p>
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <p className="text-[11px] text-gray-400 italic text-center py-3">
                No indicators selected. Use the left panel to apply filters.
              </p>
            )}
          </div>

          {/* ── Selected Villages ── */}
          {displayVillages.length > 0 && (
            <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-gray-800">
                  Selected Villages
                </h3>

                <span className="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold">
                  {displayVillages.length}
                </span>
              </div>

              <div className="max-h-44 overflow-y-auto pr-1 flex flex-wrap gap-1.5">
                {displayVillages.map((village) => (
                  <button
                    key={village.villageId}
                    type="button"
                    title={`Open report for ${village.villageName}`}
                    onClick={() => window.open(buildVillageReportUrl(village.villageId), '_blank', 'noopener,noreferrer')}
                    className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[9px] font-medium bg-emerald-50 border border-emerald-100 text-emerald-700 hover:bg-emerald-100 hover:border-emerald-300 max-w-full transition-colors"
                  >
                              <span className="truncate">{village.villageName}</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* ── Selected Patterns ── */}
          {getFormattedSelectedPatterns().length > 0 && (
            <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
              <SectionHeader title="Selected Patterns" count={getFormattedSelectedPatterns().length} />
              <div className="max-h-[140px] overflow-y-auto pr-1 space-y-1.5">
                {getFormattedSelectedPatterns().map((pattern, index) => (
                  <div key={index} className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2">
                    <div className="flex-1 min-w-0">
                      <p className="text-[11px] font-semibold text-gray-700 truncate">{pattern.category}</p>
                      {pattern.patternName && pattern.patternName !== pattern.category && (
                        <p className="text-[10px] text-gray-400 mt-0.5">{pattern.patternName}</p>
                      )}
                    </div>
                    <button
                      onClick={() => handlePatternRemoval(pattern)}
                      className={`text-gray-300 hover:text-red-400 transition-colors shrink-0 ${
                        toggleStates[pattern.patternName] ? "invisible" : ""
                      }`}
                    >
                      <X className="w-3.5 h-3.5" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default KYLRightSidebar;